import * as React from "react";

export * from "./pages/Privacy";
export * from "./pages/Terms";
